export const CONSTR_PROJECT_DEFAULT_SOLR_PARAMS = {
  T: "",
  excludeWord: "",
  filterMode: "2,1",
  keyword: "",
  keywordsAndOr: "|", // 且或关系、& = 且 、 | = 或
  newAreas: "",
  sortType: "2",
  summaryType: "0",
  timeType: "8",
  starNums: "",
  progressStageIds: "",
  industryType: "",
  industryChildType: "",
  decorationStatus: "",
  endTime: "",
  beginTime: "",
  ownerType: "",
};

export const CONSTR_PROJECT_TIME_LIST = [
  {
    id: 7,
    text: "当日",
  },
  {
    id: 2,
    text: "近7天",
  },
  {
    id: 3,
    text: "近30天",
  },
  {
    id: 8,
    text: "近90天",
  },
  {
    id: 9,
    text: "近半年",
  },
  {
    id: 1,
    text: "近一年",
  },
  {
    id: 40,
    text: "往年",
  },
  {
    id: 4,
    text: "自定义",
  },
];
export const CONSTR_PROJECT_SEARCH_SCOPE = [
  {
    text: "标题",
    id: 2,
  },
  {
    text: "正文",
    id: 1,
  },
  {
    text: "单位名称",
    id: 11,
  },
];
export const CONSTR_PROJECT_PROGRESS = [
  {
    id: 1102,
    text: "可研",
  },
  {
    id: 1106,
    text: "立项",
  },
  {
    id: 1105,
    text: "核准",
  },
  {
    id: 1103,
    text: "备案",
  },
  {
    id: 1101,
    text: "环评",
  },
  {
    id: 1104,
    text: "审批",
  },
  {
    id: 1200,
    text: "设计阶段",
  },
  {
    id: 1300,
    text: "施工准备",
  },
  {
    id: 1400,
    text: "施工在建",
  },
  {
    id: 1500,
    text: "竣工",
  },
];
export const CONSTR_PROJECT_DECORATION_STATUS = [
  {
    text: "不装修",
    id: 0,
  },
  {
    text: "精装修",
    id: 2,
  },
  {
    text: "简装修",
    id: 1,
  },
];
export const CONSTR_PROJECT_OWNER_TYPE = [
  {
    text: "政府项目",
    id: 2,
  },
  {
    text: "商业项目",
    id: 1,
  },
];
export const CONSTR_PROJECT_STAR_NUMBER = [
  {
    text: "5星",
    id: 5,
  },
  {
    text: "4星",
    id: 4,
  },
  {
    text: "3.5星",
    id: 3.5,
  },
  {
    text: "3星",
    id: 3,
  },
];
export const CONSTR_PROJECT_PROJECT_TYPE = [
  {
    id: 1,
    text: "参考",
  },
  {
    id: 2,
    text: "精选",
  },
];
